import { createSlice } from '@reduxjs/toolkit';
import { attachDetachUserToSchedule } from './Utils/ScheduleUtils';

const initialState = {
    scheduleId: '',
    userId: [],
    isLoading: false,
};

const attachDetachUserToScheduleSlice = createSlice(
    {
        name: 'attachDetachUserToSchedule',
        initialState: initialState,
        reducers: {
            setField: (state, action) => {
                const { field, value } = action.payload;
                state[field] = value;
            },
            resetState: (state) => {
                return initialState;
            },
        },
        extraReducers: (builder) => {
            builder
                .addCase(attachDetachUserToSchedule.pending, (state) => {
                    // Handle loading state
                    state.isLoading = true;
                })
                .addCase(attachDetachUserToSchedule.fulfilled, (state, action) => {
                    // Handle success state
                    state.isLoading = false;
                })
                .addCase(attachDetachUserToSchedule.rejected, (state, action) => {
                    // Handle error state
                    state.isLoading = false;
                });
        }
    }
);

export const { setField, resetState } = attachDetachUserToScheduleSlice.actions;

export default attachDetachUserToScheduleSlice.reducer;